import service from "./service"

const companyInfo = async () => {
    return service()
}

export default companyInfo